import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { anneesPeriode, formatPeriodeMois, parsePeriodeMois } from './periode-mois';

@Component({
  selector: 'periode-mois-input',
  templateUrl: './periode-mois-input.component.html'
})
export class PeriodeMoisInputComponent implements OnChanges {
  @Input() id: string;
  @Input() label: string;
  @Input() listeMois: { id: string, label: string }[] = [];
  @Input() disabled = false;
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();

  mois: string;
  annee: number;
  annees: number[] = anneesPeriode(new Date().getFullYear());

  ngOnChanges() {
    const periode = parsePeriodeMois(this.value);
    // Ne pas écraser une saisie partielle (mois sans année) tant que la valeur reste vide.
    if (this.value || formatPeriodeMois(this.mois, this.annee)) {
      this.mois = periode.mois;
      this.annee = periode.annee;
    }
    this.annees = anneesPeriode(new Date().getFullYear(), this.annee);
  }

  onMoisChange(mois: string) {
    this.mois = mois;
    if (mois && !this.annee) {
      this.annee = new Date().getFullYear();
    }
    this.emit();
  }

  onAnneeChange(annee: number) {
    this.annee = annee;
    this.emit();
  }

  private emit() {
    this.value = formatPeriodeMois(this.mois, this.annee);
    this.valueChange.emit(this.value);
  }
}
